{
  "$schema": "http://json-schema.org/draft-07/schema",
  "$id": "ProfileDefinitions",
  "definitions": {
    "ProfileSchema": {
      "type": "object",
      "description": "Public profile accessible at a base url for both Users and Orgs",
      "required": [
        "id",
        "profile_id",
        "created_by",
        "created_at",
        "deleted_by",
        "deleted_at",
        "handle",
        "user_id",
        "org_id",
        "profile_type"
      ],
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string"
        },
        "profile_id": {
          "type": "string",
          "description": "This is directly mapped to id"
        },
        "created_by": {
          "type": "string"
        },
        "created_at": {
          "type": "string",
          "format": "date-time"
        },
        "deleted_by": {
          "type": ["string", "null"],
          "format": "uuid"
        },
        "deleted_at": {
          "type": ["string", "null"],
          "format": "date-time"
        },
        "handle": {
          "type": ["string", "null"],
          "default": null,
          "maxLength": 30,
          "minLength": 4,
          "pattern": "^[a-z]+[a-z0-9_]{3,}$",
          "not": {
            "enum": [
              "soniq",
              "soniqstudio",
              "admin",
              "administrator",
              "support",
              "help",
              "security",
              "staff",
              "team",
              "status",
              "system",
              "api",
              "billing",
              "contact",
              "info",
              "noreply",
              "root",
              "owner",
              "webmaster",
              "abuse",
              "press",
              "privacy",
              "terms",
              "blog"
            ]
          },
          "errorMessage": {
            "pattern": "Must start with a lowercase letter, followed by lowercase letters, digits, or underscores, and be between 4 and 30 characters long."
          }
        },
        "profile_type": {
          "type": "string",
          "enum": ["user", "org"]
        },
        "org_id": {
          "type": ["string", "null"],
          "default": null
        },
        "user_id": {
          "type": ["string", "null"],
          "default": null
        }
      }
    }
  }
}
